import React from 'react';

const modalStyles: Record<string, React.CSSProperties> = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  },
  modal: {
    position: 'relative',
    background: '#fff',
    padding: '10px',
    borderRadius: '8px',
    maxWidth: '90%',
    maxHeight: '90%',
    overflow: 'auto',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '80vh',
    display: 'block',
  },
  closeButton: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#333',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

interface ImageModalProps {
  imageSrc: string;
  onClose: () => void;
}

function ImageModal({ imageSrc, onClose }: ImageModalProps) {
  if (!imageSrc) return null;

  return (
    <div
      role="presentation"
      style={modalStyles.backdrop}
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        style={modalStyles.modal}
        // onClick={(e) => e.stopPropagation()} // prevent click propagation to backdrop
      >
        <img src={imageSrc} alt="Full view" style={modalStyles.image} />
        <button
          type="button"
          onClick={onClose}
          style={modalStyles.closeButton}
          aria-label="Close modal"
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default ImageModal;
